<template>
  <div class="gallery-slide">
    <div class="gallery-slide__picture-wrapp">
      <BasePicture
        class="gallery-slide__picture"
        :sizes="sizes"
        :origin="fullSizeUrl"
        @click="$emit('open-image', fullSizeUrl)"
        @load="hidePlaceholder"
      />
      <LazyloadPlaceholder
        v-if="!loaded"
        class="gallery-slide__lazyload-placeholder"
      />
    </div>
    <div
      v-if="isShowCaption"
      class="gallery-slide__caption"
    >
      <TheContent
        v-for="item in caption"
        :key="item.id"
        :elem="item"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BasePicture from '@devhacker/shared/features/BasePicture/BasePicture.vue';
  import LazyloadPlaceholder from '~/components/LazyloadPlaceholder.vue';
  import TheContent from '~/components/TheContent';
  import type { TContent, TImageSize } from '~/types/common';
  export default defineNuxtComponent({
    name: 'GallerySlide',
    components: {
      LazyloadPlaceholder,
      BasePicture,
      TheContent,
    },

    props: {
      slide: {
        type: Object as PropType<TContent>,
        required: true,
      },
    },

    data: () => ({
      loaded: false,
    }),

    computed: {
      sizes(): TImageSize[] {
        return [
          this.slide.attributes.sizes[0],
          this.slide.attributes.sizes[2],
          this.slide.attributes.sizes[3],
        ];
      },

      fullSizeUrl(): string {
        return this.slide.attributes.url;
      },

      caption(): TContent[] {
        return this.slide.attributes?.parsed_caption;
      },

      isShowCaption(): boolean {
        return this.caption && this.caption.length > 0;
      },
    },

    methods: {
      hidePlaceholder() {
        this.loaded = true;
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '~/scss/gallery/Gallery.mixins.scss' as *;

  .gallery-slide {
    &__picture-wrapp {
      position: relative;

      &::before {
        content: '';
        display: block;
        // --aspect-ratio назначается в стилях Gallery.vue и миксинах Gallery.mixins.scss
        padding-top: calc(100% / var(--aspect-ratio));
      }
    }
    &__picture,
    &__lazyload-placeholder {
      position: absolute !important;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      border-radius: 32px;
      overflow: hidden;
      cursor: pointer;
      :deep() .picture__img {
        object-fit: cover;
        height: 100%;
      }
    }
    &__lazyload-placeholder {
      cursor: default;
    }
    &__caption {
      margin-top: $spacing-2;
      @include caption;
      position: relative;
    }
  }
</style>
